import * as React from 'react';

import OfflineNotification from 'components/molecules/Notification/static/Offline';
import { MatchType, WithRouterType } from 'types/withRouter';

export type ConnectionHandlerPropsType = WithRouterType & {
	currentViewID: string;
	isOnline: boolean;
	isDataBagAvailable: boolean;
	hasRequestErrors: boolean;
	hasChunkErrors: boolean;
	assumeUserIsOffline: boolean;
	signature: string;
	match: MatchType;
	anyOutgoingSaveRequestFailed: boolean;
	anyOutgoingFetchRequestFailed: boolean;
};

type ConnectionHandlerStateType = {
	initialPropsLoaded: boolean;
};

class ConnectionHandler extends React.Component<ConnectionHandlerPropsType, ConnectionHandlerStateType> {
	public static displayName = 'ConnectionHandler';

	public state: ConnectionHandlerStateType = {
		initialPropsLoaded: false,
	};

	public componentDidUpdate(prevProps: ConnectionHandlerPropsType) {
		const allPrevPropsLoaded = [
			prevProps.currentViewID,
			prevProps.isOnline,
			prevProps.isDataBagAvailable,
			prevProps.hasRequestErrors,
			prevProps.signature,
		]
			.map((val: any) => typeof val !== 'undefined')
			.filter(Boolean)
			.every((val: boolean) => val === true);

		const allPropsLoaded = [
			this.props.currentViewID,
			this.props.isOnline,
			this.props.isDataBagAvailable,
			this.props.hasRequestErrors,
			this.props.signature,
		]
			.map((val: any) => typeof val !== 'undefined')
			.filter(Boolean)
			.every((val: boolean) => val === true);

		if (allPropsLoaded && !allPrevPropsLoaded) {
			this.setState({
				initialPropsLoaded: true,
			});
		}
	}

	public render() {
		const { initialPropsLoaded } = this.state;
		const {
			isOnline,
			isDataBagAvailable,
			hasRequestErrors,
			anyOutgoingSaveRequestFailed,
			anyOutgoingFetchRequestFailed,
		} = this.props;

		if (isOnline) {
			return null;
		}

		if (!initialPropsLoaded) {
			return null;
		}

		if (anyOutgoingSaveRequestFailed) {
			return <OfflineNotification />;
		}

		if (isDataBagAvailable) {
			return null;
		}

		if (anyOutgoingFetchRequestFailed || hasRequestErrors) {
			return <OfflineNotification />;
		}

		return null;
	}
}

export default ConnectionHandler;
